import { render, staticRenderFns } from "./icon-insta.vue?vue&type=template&id=541ef76c&scoped=true"
import script from "./icon-insta.vue?vue&type=script&lang=js"
export * from "./icon-insta.vue?vue&type=script&lang=js"
import style0 from "./icon-insta.vue?vue&type=style&index=0&id=541ef76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ef76c",
  null
  
)

export default component.exports